module.exports = __webpack_public_path__ + "static/media/MASPHINFO.f74b995a.png";